/** Numeric enum for API requests (POST/PUT body). Matches backend WorkspaceRole enum. */
export type WorkspaceRole = 0 | 1 | 2 | 3; // 0=Owner, 1=Admin, 2=ProjectManager, 3=TeamMember

/** String values returned by the backend in GET responses */
export type WorkspaceRoleString = 'Owner' | 'Admin' | 'ProjectManager' | 'TeamMember';

export const WorkspaceRoleLabels: Record<WorkspaceRoleString, string> = {
  Owner: 'Owner',
  Admin: 'Admin',
  ProjectManager: 'Project Manager',
  TeamMember: 'Team Member',
};
export type MemberStatus = 'Active' | 'Inactive';

export interface TeamMember {
  userId: string;
  name: string;
  email: string;
  avatarUrl?: string;
  role: WorkspaceRoleString;
  status: MemberStatus;
  billableRate?: number;
  joinedAt: string;
}

export interface InviteMemberDto {
  email: string;
  role: WorkspaceRole;
}

export interface UpdateMemberRoleDto {
  role: WorkspaceRole;
}

export interface SetBillableRateDto {
  billableRate?: number;
}
